<template>
    <div></div>
</template>

<script>
    export default {
        name: "Test",
        created() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            alert(userInfo.id);
            let length = Object.keys(userInfo);
            alert(length);
            // if(userInfo){
            //     let length = Object.keys(userInfo);
            //     if(length.length){
            //         store.dispatch('setUserInfo',userInfo);
            //     }
            // }
        }
    }
</script>

<style scoped>

</style>
